export enum EditionAppDetailsMode {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
}
